module.exports = __webpack_public_path__ + "img/info.ca76dafc.svg";